import React from 'react';
import { twMerge } from 'tailwind-merge';
export var LoadingCircle = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.classNames, classNames = _c === void 0 ? '' : _c;
    return (React.createElement("div", { className: twMerge('border-t-solid h-30 w-30 animate-spin rounded-full border-10 border-t-10 border-solid border-lighter-gray border-t-blue table-and-mobile:h-20 table-and-mobile:w-20', classNames), style: style }));
};
